export default __webpack_public_path__ + "static/media/home-box.9863e0b1.png";